import { isPending } from "App/apiMiddleware";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import { createSelector } from "reselect";
import { NAMESPACE, PAGE_NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const getData = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].data`), (data) => data);
export const getChanges = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].draft`), (draft) => draft);
export const getHasChanges = createSelector((state) => getChanges(state), (draft) => !isEmpty(draft));
export const getSummaryReportId = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].summaryReportId`), (summaryReportId) => summaryReportId);
export const getDraft = createSelector((state) => getData(state), (state) => getChanges(state), (state) => getSummaryReportId(state), (data, draft, summaryReportId) => {
    if (isNil(summaryReportId) || !data)
        return undefined;
    return {
        ...data,
        ...(draft || {})
    };
});
export const getInProgress = (state) => isPending(state, `${actionTypes.SAVE_SUMMARY_REPORT}_${getSummaryReportId(state)}`) ||
    isPending(state, `${actionTypes.GET_SUMMARY_REPORT}_${getSummaryReportId(state)}`);
